// src/pages/Parametros/tabs/TabPorMetrica.jsx
import React from 'react';
import {
    Box, TextField, Typography, Paper,
    Select, MenuItem, FormControl, InputLabel,
    InputAdornment, Chip,
} from '@mui/material';
import { useParametrosAnalise } from '../../../context/ParametrosAnaliseContext';

function MetricaCard({ label, chipLabel, chipColor, metrica, data, onUpdate }) {
    const set = (field, value) => onUpdate(metrica, { [field]: value });

    return (
        <Paper
            variant="outlined"
            sx={{ p: 3, flex: 1, minWidth: 280, borderColor: chipColor }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                <Typography variant="subtitle1" fontWeight={700}>{label}</Typography>
                <Chip
                    label={chipLabel}
                    size="small"
                    sx={{ bgcolor: chipColor, color: '#fff', fontWeight: 700 }}
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <FormControl fullWidth>
                    <InputLabel>Sensor</InputLabel>
                    <Select
                        value={data.sensor}
                        label="Sensor"
                        onChange={(e) => set('sensor', e.target.value)}
                    >
                        <MenuItem value="turbidimetry">turbidimetry</MenuItem>
                        <MenuItem value="fluorescence">fluorescence</MenuItem>
                    </Select>
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel>Canal</InputLabel>
                    <Select
                        value={data.canal}
                        label="Canal"
                        onChange={(e) => set('canal', e.target.value)}
                    >
                        <MenuItem value="F1">F1</MenuItem>
                        <MenuItem value="F2">F2</MenuItem>
                        <MenuItem value="F3">F3</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    label="Limiar de amplitude"
                    type="number"
                    value={data.limiarAmplitude}
                    onChange={(e) => set('limiarAmplitude', Number(e.target.value))}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                    }}
                    inputProps={{ min: 0, step: 0.5 }}
                    fullWidth
                />
                <TextField
                    label="Limiar de ratio"
                    type="number"
                    value={data.limiarRatio}
                    onChange={(e) => set('limiarRatio', Number(e.target.value))}
                    inputProps={{ min: 1, step: 0.01 }}
                    fullWidth
                />
            </Box>
        </Paper>
    );
}

export default function TabPorMetrica() {
    const { params, updateMetrica } = useParametrosAnalise();

    return (
        <Box sx={{ pt: 3 }}>
            <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                <MetricaCard
                    label="Coliformes Totais"
                    chipLabel="CT"
                    chipColor="#1976d2"
                    metrica="coliformesTotais"
                    data={params.metricas.coliformesTotais}
                    onUpdate={updateMetrica}
                />
                <MetricaCard
                    label="E. coli"
                    chipLabel="EC"
                    chipColor="#7b1fa2"
                    metrica="ecoli"
                    data={params.metricas.ecoli}
                    onUpdate={updateMetrica}
                />
            </Box>
        </Box>
    );
}
